import { invert } from "lodash"

enum TerminationTypes {
  Backward = 1,
  Forward = 2,
}

export const TerminationNames = invert(TerminationTypes)

export default TerminationTypes
